const INITIAL_STATE = {
        visible: '0'
      
  };
  
  const applyAppState = (state, action) => ({
    ...state,
    visible: action.value
  });

  
  function appStateReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      
      case 'CHANGE_VIEW' : {
        return applyAppState(state, action);
       
      }
      default : return state;
    }
  }
  
  export default appStateReducer;


// WEBPACK FOOTER //
// ./src/Components/InAppNav/inAppNavReducer.js